import { render } from "./FilterBox.vue?vue&type=template&id=7b54fae2&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=js"
export * from "./FilterBox.vue?vue&type=script&lang=js"

import "./FilterBox.vue?vue&type=style&index=0&id=7b54fae2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b54fae2"]])

export default __exports__